module.exports = __webpack_public_path__ + "static/media/farmers_fridge.dc154290.png";